// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== B-book report screens: A-book vs B-book, house P&L ===== */

.b_book_page .b_book_report_section {
    margin-top: var(--bb-space-6, 32px);
}

.b_book_page .b_book_report_section h2 {
    margin: 0 0 6px;
    font-size: 20px;
    font-weight: 600;
}

.b_book_page .b_book_report_grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
    margin-bottom: 20px;
}

.b_book_page .b_book_report_card {
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    padding: 20px;
    min-width: 0;
}

.b_book_page .b_book_report_card h3 {
    margin: 0 0 12px;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
}

.b_book_page .b_book_report_card_wide {
    grid-column: span 2;
}

.b_book_page .b_book_report_card_full {
    grid-column: 1 / -1; /* tables need the room: 5-6 columns truncate in a third of the width */
}

.b_book_page .b_book_report_card .table-container,
.b_book_page .b_book_report_card .table-column {
    width: 100%;
}

.b_book_page .b_book_report_refreshing {
    opacity: 0.55;
    transition: opacity 0.15s ease;
}

.b_book_page .b_book_report_empty {
    margin: 40px 0;
    text-align: center;
    color: var(--bb-soft);
}

/* ----- charts ----- */

.b_book_page .b_book_chart {
    margin: 0;
}

/* a global rule makes every ul a flex column, which blockifies the legend items: lay the list out as a row */
.b_book_page .b_book_report_card .recharts-default-legend {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
}

.b_book_page .b_book_report_card .recharts-default-legend li {
    width: auto;
}

.b_book_page .b_book_report_card .recharts-cartesian-axis-tick-value {
    font-size: 12px;
    fill: var(--bb-soft);
    font-variant-numeric: tabular-nums;
}

.b_book_page .b_book_bar_label {
    font-size: 12px;
    font-weight: 600;
    fill: var(--text-primary);
    font-variant-numeric: tabular-nums;
}

.b_book_page .b_book_report_share_legend {
    list-style: none;
    margin: 8px 0 0;
    padding: 0;
    gap: 8px;
}

.b_book_page .b_book_report_share_legend li {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-variant-numeric: tabular-nums;
}

.b_book_page .b_book_report_swatch {
    width: 12px;
    height: 12px;
    border-radius: 3px;
    flex-shrink: 0;
}

.b_book_page .b_book_report_share_amount {
    margin-left: auto;
    color: var(--bb-soft);
}

/* ----- KPI tiles: read-only, so no hover lift or pointer ----- */

.b_book_page .b_book_kpis {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
    padding: 12px 0 20px;
}

.b_book_page .b_book_kpis.b_book_kpis_4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.b_book_page .b_book_kpi {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
    padding: 16px 18px;
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
}

.b_book_page .b_book_kpi_label {
    margin: 0;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    line-height: 1.35;
    color: var(--bb-soft);
}

.b_book_page .b_book_kpi_value {
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1.2;
    color: var(--text-primary);
    font-variant-numeric: tabular-nums;
    overflow-wrap: anywhere;
}

.b_book_page .b_book_kpi_gain {
    color: var(--bb-gain);
}

.b_book_page .b_book_kpi_loss {
    color: var(--bb-loss);
}

.b_book_page .b_book_kpi_hint {
    margin: 0;
    font-size: 12px;
    line-height: 1.45;
    color: var(--bb-soft);
}

/* ----- live block ----- */

.b_book_page .b_book_pnl_live_head,
.b_book_page .b_book_pnl_period_head {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.b_book_page .b_book_pnl_period_head {
    padding-top: var(--bb-space-5, 24px);
    border-top: 1px solid var(--border);
}

.b_book_page .b_book_live_stamp {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: var(--bb-soft);
    font-variant-numeric: tabular-nums;
}

.b_book_page .b_book_live_dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: var(--bb-gain);
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--bb-gain) 25%, transparent);
}

.b_book_page .b_book_live_stamp_stale {
    color: var(--bb-warn);
}

.b_book_page .b_book_live_stamp_stale .b_book_live_dot {
    background-color: var(--bb-warn);
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--bb-warn) 25%, transparent);
}

.b_book_page .b_book_skeleton {
    height: 220px;
    margin-top: 16px;
    border-radius: var(--radius-md);
    background: linear-gradient(90deg, var(--bg-card) 0%, var(--bg) 50%, var(--bg-card) 100%);
    background-size: 200% 100%;
    animation: b_book_shimmer 1.4s ease-in-out infinite;
}

@keyframes b_book_shimmer {
    from { background-position: 100% 0; }
    to { background-position: -100% 0; }
}

.b_book_page .b_book_pnl_gauge_head {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 8px 12px;
    margin-bottom: 12px;
}

.b_book_page .b_book_pnl_gauge_head strong {
    font-size: 28px;
    line-height: 1;
}

.b_book_page .b_book_pnl_gauge_head span {
    color: var(--bb-soft);
}

.b_book_page .b_book_level {
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid;
}

.b_book_page .b_book_pnl_gauge_head .b_book_level_success {
    color: var(--bb-gain);
}

.b_book_page .b_book_pnl_gauge_head .b_book_level_warning {
    color: var(--bb-warn);
}

.b_book_page .b_book_pnl_gauge_head .b_book_level_danger {
    color: var(--bb-loss);
}

.b_book_page .b_book_pnl_gauge_track {
    position: relative;
    height: 14px;
    margin-bottom: 16px;
    border-radius: var(--radius-sm);
    background-color: var(--border);
    overflow: visible;
}

/* scaled, not resized: the bar moves on the compositor, no layout on every refresh */
.b_book_page .b_book_pnl_gauge_fill {
    width: 100%;
    height: 100%;
    border-radius: var(--radius-sm);
    transform-origin: left center;
    transition: transform 0.3s ease-out;
}

.b_book_page .b_book_pnl_gauge_marker {
    position: absolute;
    top: -4px;
    width: 2px;
    height: 22px;
    background-color: var(--text-secondary);
}

.b_book_page .b_book_pnl_engine_meta {
    margin: 14px 0 10px;
    font-size: 13px;
    color: var(--bb-soft);
    font-variant-numeric: tabular-nums;
}

.b_book_page .b_book_pnl_link {
    display: inline-flex;
    align-items: center;
    min-height: 24px;
    font-size: 14px;
    font-weight: 600;
    color: var(--primary);
    text-decoration: none;
}

.b_book_page .b_book_pnl_link:hover {
    text-decoration: underline;
}

/* ----- responsive ----- */

@media (max-width: 1100px) {
    .b_book_page .b_book_report_grid {
        grid-template-columns: minmax(0, 1fr);
    }

    .b_book_page .b_book_report_card_wide {
        grid-column: auto;
    }

    .b_book_page .b_book_kpis,
    .b_book_page .b_book_kpis.b_book_kpis_4 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .b_book_page .b_book_kpis,
    .b_book_page .b_book_kpis.b_book_kpis_4 {
        grid-template-columns: minmax(0, 1fr);
    }

    .b_book_page .b_book_kpi_value {
        font-size: 22px;
    }
}

/* ----- (i) explanations ----- */

.b_book_page .b_book_kpi,
.b_book_page .b_book_report_card {
    position: relative;
}

.b_book_page .b_book_info {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 5;
}

.b_book_page .b_book_info_button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px; /* the smallest target WCAG asks for */
    padding: 0;
    border: 1px solid var(--border);
    border-radius: 50%;
    background-color: var(--bg);
    color: var(--bb-soft);
    font: italic 700 13px/1 Georgia, 'Times New Roman', serif;
    cursor: help;
    transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.b_book_page .b_book_info_button:hover,
.b_book_page .b_book_info_button[aria-expanded="true"] {
    background-color: var(--primary-light);
    border-color: var(--primary);
    color: var(--primary);
}

.b_book_info_bubble { /* rendered at the end of the document (portal), so not under .b_book_page */
    position: fixed;
    z-index: 1000;
    box-sizing: border-box;
    padding: 10px 12px;
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    background-color: var(--bg-card);
    box-shadow: var(--shadow-lg);
    color: var(--text-primary);
    font-size: 13px;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-transform: none;
    letter-spacing: 0;
    white-space: normal;
}


/* the label runs under the corner icon otherwise */
.b_book_page .b_book_kpi_label,
.b_book_page .b_book_report_card h3 {
    padding-right: 30px;
}

.b_book_page .b_book_info::after { /* bridges the gap so the pointer can reach the bubble */
    content: '';
    position: absolute;
    top: 100%;
    right: 0;
    width: 100%;
    height: 8px;
}

/* ----- period: timezone beside the date picker ----- */

.b_book_page .b_book_period_controls {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--bb-space-3, 12px);
}

.b_book_page .b_book_zone_select {
    display: flex;
    align-items: center;
    gap: 8px;
}

.b_book_page .b_book_zone_select label {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
}

.b_book_page .b_book_zone_select select {
    min-height: 36px;
    background-color: var(--bg);
    cursor: pointer;
}

/* five live tiles: the four of old plus the margin funded at LMAX */
.b_book_page .b_book_kpis.b_book_kpis_5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
}

@media (max-width: 1400px) {
    .b_book_page .b_book_kpis.b_book_kpis_5 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 1100px) {
    .b_book_page .b_book_kpis.b_book_kpis_5 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .b_book_page .b_book_kpis.b_book_kpis_5 {
        grid-template-columns: minmax(0, 1fr);
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/bBook/bBookReport.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE;IACI,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB,EAAE,uEAAuE;AAChG;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,uBAAuB;;AAEvB;IACI,SAAS;AACb;;AAEA,6GAA6G;AAC7G;IACI,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA,kEAAkE;;AAElE;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,0BAA0B;IAC1B,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA,2BAA2B;;AAE3B;;IAEI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,yEAAyE;AAC7E;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,yEAAyE;AAC7E;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,+BAA+B;IAC/B,yFAAyF;IACzF,0BAA0B;IAC1B,mDAAmD;AACvD;;AAEA;IACI,OAAO,2BAA2B,EAAE;IACpC,KAAK,4BAA4B,EAAE;AACvC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA,qFAAqF;AACrF;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,6BAA6B;IAC7B,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,2BAA2B;;AAE3B;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,gDAAgD;IACpD;AACJ;;AAEA;IACI;;QAEI,qCAAqC;IACzC;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,iCAAiC;;AAEjC;;IAEI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY,EAAE,sCAAsC;IACpD,UAAU;IACV,+BAA+B;IAC/B,kBAAkB;IAClB,2BAA2B;IAC3B,qBAAqB;IACrB,yDAAyD;IACzD,YAAY;IACZ,kFAAkF;AACtF;;AAEA;;IAEI,sCAAsC;IACtC,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA,sBAAsB,4EAA4E;IAC9F,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,+BAA+B;IAC/B,+BAA+B;IAC/B,gCAAgC;IAChC,4BAA4B;IAC5B,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;AACvB;;;AAGA,mDAAmD;AACnD;;IAEI,mBAAmB;AACvB;;AAEA,mCAAmC,wDAAwD;IACvF,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,WAAW;AACf;;AAEA,wDAAwD;;AAExD;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,oEAAoE;AACpE;IACI,gDAAgD;AACpD;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ","sourcesContent":["/* ===== B-book report screens: A-book vs B-book, house P&L ===== */\n\n.b_book_page .b_book_report_section {\n    margin-top: var(--bb-space-6, 32px);\n}\n\n.b_book_page .b_book_report_section h2 {\n    margin: 0 0 6px;\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.b_book_page .b_book_report_grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.b_book_page .b_book_report_card {\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-sm);\n    padding: 20px;\n    min-width: 0;\n}\n\n.b_book_page .b_book_report_card h3 {\n    margin: 0 0 12px;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.b_book_page .b_book_report_card_wide {\n    grid-column: span 2;\n}\n\n.b_book_page .b_book_report_card_full {\n    grid-column: 1 / -1; /* tables need the room: 5-6 columns truncate in a third of the width */\n}\n\n.b_book_page .b_book_report_card .table-container,\n.b_book_page .b_book_report_card .table-column {\n    width: 100%;\n}\n\n.b_book_page .b_book_report_refreshing {\n    opacity: 0.55;\n    transition: opacity 0.15s ease;\n}\n\n.b_book_page .b_book_report_empty {\n    margin: 40px 0;\n    text-align: center;\n    color: var(--bb-soft);\n}\n\n/* ----- charts ----- */\n\n.b_book_page .b_book_chart {\n    margin: 0;\n}\n\n/* a global rule makes every ul a flex column, which blockifies the legend items: lay the list out as a row */\n.b_book_page .b_book_report_card .recharts-default-legend {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 16px;\n}\n\n.b_book_page .b_book_report_card .recharts-default-legend li {\n    width: auto;\n}\n\n.b_book_page .b_book_report_card .recharts-cartesian-axis-tick-value {\n    font-size: 12px;\n    fill: var(--bb-soft);\n    font-variant-numeric: tabular-nums;\n}\n\n.b_book_page .b_book_bar_label {\n    font-size: 12px;\n    font-weight: 600;\n    fill: var(--text-primary);\n    font-variant-numeric: tabular-nums;\n}\n\n.b_book_page .b_book_report_share_legend {\n    list-style: none;\n    margin: 8px 0 0;\n    padding: 0;\n    gap: 8px;\n}\n\n.b_book_page .b_book_report_share_legend li {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-variant-numeric: tabular-nums;\n}\n\n.b_book_page .b_book_report_swatch {\n    width: 12px;\n    height: 12px;\n    border-radius: 3px;\n    flex-shrink: 0;\n}\n\n.b_book_page .b_book_report_share_amount {\n    margin-left: auto;\n    color: var(--bb-soft);\n}\n\n/* ----- KPI tiles: read-only, so no hover lift or pointer ----- */\n\n.b_book_page .b_book_kpis {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 14px;\n    padding: 12px 0 20px;\n}\n\n.b_book_page .b_book_kpis.b_book_kpis_4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.b_book_page .b_book_kpi {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    min-width: 0;\n    padding: 16px 18px;\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n}\n\n.b_book_page .b_book_kpi_label {\n    margin: 0;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    line-height: 1.35;\n    color: var(--bb-soft);\n}\n\n.b_book_page .b_book_kpi_value {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin: 0;\n    font-size: 24px;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n    color: var(--text-primary);\n    font-variant-numeric: tabular-nums;\n    overflow-wrap: anywhere;\n}\n\n.b_book_page .b_book_kpi_gain {\n    color: var(--bb-gain);\n}\n\n.b_book_page .b_book_kpi_loss {\n    color: var(--bb-loss);\n}\n\n.b_book_page .b_book_kpi_hint {\n    margin: 0;\n    font-size: 12px;\n    line-height: 1.45;\n    color: var(--bb-soft);\n}\n\n/* ----- live block ----- */\n\n.b_book_page .b_book_pnl_live_head,\n.b_book_page .b_book_pnl_period_head {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n}\n\n.b_book_page .b_book_pnl_period_head {\n    padding-top: var(--bb-space-5, 24px);\n    border-top: 1px solid var(--border);\n}\n\n.b_book_page .b_book_live_stamp {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    color: var(--bb-soft);\n    font-variant-numeric: tabular-nums;\n}\n\n.b_book_page .b_book_live_dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background-color: var(--bb-gain);\n    box-shadow: 0 0 0 3px color-mix(in srgb, var(--bb-gain) 25%, transparent);\n}\n\n.b_book_page .b_book_live_stamp_stale {\n    color: var(--bb-warn);\n}\n\n.b_book_page .b_book_live_stamp_stale .b_book_live_dot {\n    background-color: var(--bb-warn);\n    box-shadow: 0 0 0 3px color-mix(in srgb, var(--bb-warn) 25%, transparent);\n}\n\n.b_book_page .b_book_skeleton {\n    height: 220px;\n    margin-top: 16px;\n    border-radius: var(--radius-md);\n    background: linear-gradient(90deg, var(--bg-card) 0%, var(--bg) 50%, var(--bg-card) 100%);\n    background-size: 200% 100%;\n    animation: b_book_shimmer 1.4s ease-in-out infinite;\n}\n\n@keyframes b_book_shimmer {\n    from { background-position: 100% 0; }\n    to { background-position: -100% 0; }\n}\n\n.b_book_page .b_book_pnl_gauge_head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 8px 12px;\n    margin-bottom: 12px;\n}\n\n.b_book_page .b_book_pnl_gauge_head strong {\n    font-size: 28px;\n    line-height: 1;\n}\n\n.b_book_page .b_book_pnl_gauge_head span {\n    color: var(--bb-soft);\n}\n\n.b_book_page .b_book_level {\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 600;\n    border: 1px solid;\n}\n\n.b_book_page .b_book_pnl_gauge_head .b_book_level_success {\n    color: var(--bb-gain);\n}\n\n.b_book_page .b_book_pnl_gauge_head .b_book_level_warning {\n    color: var(--bb-warn);\n}\n\n.b_book_page .b_book_pnl_gauge_head .b_book_level_danger {\n    color: var(--bb-loss);\n}\n\n.b_book_page .b_book_pnl_gauge_track {\n    position: relative;\n    height: 14px;\n    margin-bottom: 16px;\n    border-radius: var(--radius-sm);\n    background-color: var(--border);\n    overflow: visible;\n}\n\n/* scaled, not resized: the bar moves on the compositor, no layout on every refresh */\n.b_book_page .b_book_pnl_gauge_fill {\n    width: 100%;\n    height: 100%;\n    border-radius: var(--radius-sm);\n    transform-origin: left center;\n    transition: transform 0.3s ease-out;\n}\n\n.b_book_page .b_book_pnl_gauge_marker {\n    position: absolute;\n    top: -4px;\n    width: 2px;\n    height: 22px;\n    background-color: var(--text-secondary);\n}\n\n.b_book_page .b_book_pnl_engine_meta {\n    margin: 14px 0 10px;\n    font-size: 13px;\n    color: var(--bb-soft);\n    font-variant-numeric: tabular-nums;\n}\n\n.b_book_page .b_book_pnl_link {\n    display: inline-flex;\n    align-items: center;\n    min-height: 24px;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--primary);\n    text-decoration: none;\n}\n\n.b_book_page .b_book_pnl_link:hover {\n    text-decoration: underline;\n}\n\n/* ----- responsive ----- */\n\n@media (max-width: 1100px) {\n    .b_book_page .b_book_report_grid {\n        grid-template-columns: minmax(0, 1fr);\n    }\n\n    .b_book_page .b_book_report_card_wide {\n        grid-column: auto;\n    }\n\n    .b_book_page .b_book_kpis,\n    .b_book_page .b_book_kpis.b_book_kpis_4 {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 768px) {\n    .b_book_page .b_book_kpis,\n    .b_book_page .b_book_kpis.b_book_kpis_4 {\n        grid-template-columns: minmax(0, 1fr);\n    }\n\n    .b_book_page .b_book_kpi_value {\n        font-size: 22px;\n    }\n}\n\n/* ----- (i) explanations ----- */\n\n.b_book_page .b_book_kpi,\n.b_book_page .b_book_report_card {\n    position: relative;\n}\n\n.b_book_page .b_book_info {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    z-index: 5;\n}\n\n.b_book_page .b_book_info_button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px; /* the smallest target WCAG asks for */\n    padding: 0;\n    border: 1px solid var(--border);\n    border-radius: 50%;\n    background-color: var(--bg);\n    color: var(--bb-soft);\n    font: italic 700 13px/1 Georgia, 'Times New Roman', serif;\n    cursor: help;\n    transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.b_book_page .b_book_info_button:hover,\n.b_book_page .b_book_info_button[aria-expanded=\"true\"] {\n    background-color: var(--primary-light);\n    border-color: var(--primary);\n    color: var(--primary);\n}\n\n.b_book_info_bubble { /* rendered at the end of the document (portal), so not under .b_book_page */\n    position: fixed;\n    z-index: 1000;\n    box-sizing: border-box;\n    padding: 10px 12px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    background-color: var(--bg-card);\n    box-shadow: var(--shadow-lg);\n    color: var(--text-primary);\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-transform: none;\n    letter-spacing: 0;\n    white-space: normal;\n}\n\n\n/* the label runs under the corner icon otherwise */\n.b_book_page .b_book_kpi_label,\n.b_book_page .b_book_report_card h3 {\n    padding-right: 30px;\n}\n\n.b_book_page .b_book_info::after { /* bridges the gap so the pointer can reach the bubble */\n    content: '';\n    position: absolute;\n    top: 100%;\n    right: 0;\n    width: 100%;\n    height: 8px;\n}\n\n/* ----- period: timezone beside the date picker ----- */\n\n.b_book_page .b_book_period_controls {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: var(--bb-space-3, 12px);\n}\n\n.b_book_page .b_book_zone_select {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.b_book_page .b_book_zone_select label {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.b_book_page .b_book_zone_select select {\n    min-height: 36px;\n    background-color: var(--bg);\n    cursor: pointer;\n}\n\n/* five live tiles: the four of old plus the margin funded at LMAX */\n.b_book_page .b_book_kpis.b_book_kpis_5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n@media (max-width: 1400px) {\n    .b_book_page .b_book_kpis.b_book_kpis_5 {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 1100px) {\n    .b_book_page .b_book_kpis.b_book_kpis_5 {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 768px) {\n    .b_book_page .b_book_kpis.b_book_kpis_5 {\n        grid-template-columns: minmax(0, 1fr);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
